import { render, staticRenderFns } from "./ConfirmDeleteElementComponent.vue?vue&type=template&id=f819cbc0&"
import script from "@/components/elements/ConfirmDeleteElementComponent/ConfirmDeleteElementComponent.ts?vue&type=script&lang=js&"
export * from "@/components/elements/ConfirmDeleteElementComponent/ConfirmDeleteElementComponent.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports